import { useTranslation } from "react-i18next";
import { useCase } from "../../context/CaseContext";
import { SegmentedControl } from "../general/SegmentedControl";

/**
 * Whether an issue, or a claim without issues, is won against each defendant
 * separately or once against all of them.
 */
export const IssueKindControl = ({
  of,
  generic,
  onSwitchToGeneric,
  onSwitchToSpecific,
}: {
  // decides the wording of the explanations
  of: "issue" | "claim";
  generic: boolean;
  onSwitchToGeneric: () => void;
  onSwitchToSpecific: () => void;
}) => {
  const { t } = useTranslation(undefined, { keyPrefix: "case.claims.kind" });
  const { readOnly } = useCase();

  return (
    <SegmentedControl
      ariaLabel={t("label")}
      disabled={readOnly}
      value={generic ? "generic" : "specific"}
      options={[
        {
          value: "specific",
          label: t("specific"),
          title: t(`hint.${of}.specific`),
        },
        {
          value: "generic",
          label: t("generic"),
          title: t(`hint.${of}.generic`),
        },
      ]}
      onChange={(kind) =>
        kind === "generic" ? onSwitchToGeneric() : onSwitchToSpecific()
      }
    />
  );
};
